import type React from 'react';

interface Props {
  children?: React.ReactNode;
}

export default function ({ children }: Props) {
  return <div className="flex w-full items-center justify-start bg-white pb-2">{children}</div>;
}
